var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showBoleto
    ? _c(
        "fieldset-component",
        {
          attrs: {
            title: _vm.$t(
              "__.Components.parent.venda.pagamento_vue_html.boleto"
            ),
            collapsed: false,
          },
        },
        [
          _c("div", { attrs: { slot: "rows" }, slot: "rows" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm-3" }, [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip",
                        value: _vm.errors.first("gateway"),
                        expression: "errors.first('gateway')",
                      },
                    ],
                    staticClass: "form-group",
                  },
                  [
                    _c(
                      "label",
                      {
                        staticClass: "control-label",
                        attrs: {
                          for: "gateway",
                          title: _vm.$t("__.obrigatorio"),
                        },
                      },
                      [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v("*"),
                        ]),
                        _vm._v(
                          "\n                        " +
                            _vm._s(
                              _vm.$t(
                                "__.Crud.configuracaoFranquiaGatewayPagamento.edit_vue_html.gatewayPagamento"
                              )
                            ) +
                            "\n                    "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("combo-component", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'",
                        },
                      ],
                      attrs: {
                        id: "gateway",
                        name: "gateway",
                        data: _vm.gatewaysOptions,
                        disabled: _vm.boletoPago,
                      },
                      model: {
                        value: _vm.gateway,
                        callback: function ($$v) {
                          _vm.gateway = $$v
                        },
                        expression: "gateway",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _c("div", { staticClass: "form-group" }, [
                  _c(
                    "label",
                    {
                      staticClass: "control-label",
                      attrs: { for: "linkBoletoPagamento" },
                    },
                    [
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$t(
                              "__.Components.parent.venda.pagamento_vue_html.linkBoleto"
                            )
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.linkBoletoPagamento,
                        expression: "linkBoletoPagamento",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "linkBoletoPagamento",
                      name: "linkBoletoPagamento",
                      autocomplete: "off",
                      disabled: "",
                    },
                    domProps: { value: _vm.linkBoletoPagamento },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.linkBoletoPagamento = $event.target.value
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _vm.linkBoletoPagamento.length > 0
                ? _c("div", { staticClass: "col-sm-1 input-with-icon" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", {
                        staticClass: "control-label",
                        attrs: { for: "detalhesTaxaEntrega" },
                      }),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass:
                            "input-group-addon form-control input-with-icon-wrapper",
                          attrs: {
                            title: _vm.$t(
                              "__.Components.parent.venda.linkPagamento_vue_html.copiarAreaTransf"
                            ),
                          },
                          on: { click: _vm.copiarLinkBoleto },
                        },
                        [_c("span", { staticClass: "fas fa-copy" })]
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-sm-12 buttonIncluir-container" },
                [
                  _vm.boletoPago
                    ? _c("infoBagdeComponent", {
                        attrs: { text: "Boleto está pago" },
                      })
                    : _c("buttonScComponent", {
                        staticStyle: { margin: "10px", "margin-left": "0px" },
                        attrs: {
                          classButton: "btn btn-secondary",
                          buttonName: _vm.$t(
                            "__.Components.parent.venda.pagamento_vue_html.gerarBoleto"
                          ),
                          disabled: _vm.boletoPago,
                        },
                        on: { click: _vm.criarBoleto },
                      }),
                ],
                1
              ),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }